<template>
	<div class="knd-image-container" ref="container">
		<figure class="knd-figure" :class="['size-' + classSize]">
			<img
				class="lazy"
				:alt="imgObj.description"
				:data-srcset="
					baseUrl + imgObj.mobile_url  + ' 300w, ' + 
					baseUrl + imgObj.url + ' 600w'
				"
				:data-src="baseUrl + imgObj.mobile_url"
				sizes="(max-width: 600px) 300px,600px"
			/>
			<figcaption class="imagepart__caption" v-html="imgObj.description" />
		</figure>
	</div>
</template>

<script>
export default {
	name: 'ImagePart',
	props: ['media', 'size'],

	data () {
		let img = this.media;
		let classSize = this.size.length > 0? this.size[0].titel : 'md';

		return {
			baseUrl: process.env.VUE_APP_PBASE,
			imgObj: img[0],
			classSize
		}
	},

	mounted() {
		this.insertLazy();
	},

	methods: {
		dynamicClass() {

		},
		insertLazy() {
			var lazyImages = [].slice.call(this.$refs.container.querySelectorAll("img.lazy"));

				if ("IntersectionObserver" in window) {
					let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
						entries.forEach(function(entry) {
							if (entry.isIntersecting) {
								let lazyImage = entry.target;
								lazyImage.src = lazyImage.dataset.src;
								lazyImage.srcset = lazyImage.dataset.srcset;
								lazyImage.classList.remove("lazy");
								lazyImageObserver.unobserve(lazyImage);
							}
						});
					}, { threshold: 1 });

					lazyImages.forEach(function(lazyImage) {
						lazyImageObserver.observe(lazyImage);
					});
			}
		}
	}
}
</script>

<style lang="scss">

.knd-figure {
  margin: 0 auto;
	// background: $off-white;

	&.size-sm {
		max-width: 150px;
	}
	
  img {
		width: 100%;
		display: block;
		
		transition: height .2s ease-in, opacity .5s ease-in;
		
		&.lazy {
			opacity: 0;
			height: 200px;
			width: 100%;
		}
  }
  .imagepart__caption {
    text-align: right;
  }
}

</style>